/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    DAY: 'day',
    MONTH: 'month',
    YEAR: 'year',
};
